<div class="modal-header">
  <h4 class="modal-title">Edit Conversation Name</h4>
  <button type="button" class="custom-close-btn" (click)="onCancel()" aria-label="Close">
    <img src="assets/icons/close-icon.svg" alt="close">
  </button>
</div>

<div class="modal-body">
  <p class="modal-description">Enter a new name for this conversation.</p>

  <div class="form-group">
    <label for="conversationName" class="form-label">Conversation Name</label>
    <input
      id="conversationName"
      type="text"
      class="form-control"
      [(ngModel)]="editedName"
      placeholder="Enter conversation name"
      maxlength="120"
      autofocus
    />
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-save" (click)="onSave()" [disabled]="!editedName.trim()">Save</button>
</div>
